// Formats a capture's created_at/updated_at ISO timestamp into a short
// locale-aware date-only string (e.g. "2026/07/16" / "07/16/2026") for
// display on capture cards. Returns an empty string for missing/invalid
// timestamps.
export function formatCaptureDate(isoString, language) {
  if (!isoString) return "";
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(language === "zh" ? "zh-CN" : "en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}
